module.exports = __webpack_public_path__ + "static/media/img3.dd75397e.jpeg";